import * as React from "react";
import { Image } from "semantic-ui-react";

import { VideoProject } from "@/services/bedrock";
import { formatVideoProjectStatusDate, URLS, useSocialCoachSession } from "../../../utils";

import { Svg } from "../../../assets";
import { ThumbnailPreview, VideoProjectCardContentStyle, VideoProjectCardStyle, VideoProjectHeader } from "./styled";

import "./styles.scss";

interface OwnProps {
  videoProject: VideoProject;
}

type Props = OwnProps;

const VideoProjectCardFC: React.FC<Props> = ({
  videoProject: { id, thumbnailUrl, statusLabel, statusDate, needsAck },
}: Props) => {
  const { isCoach } = useSocialCoachSession();
  const url = (isCoach ? URLS.coach.videoProject : URLS.player.videoProject).replace(":id", `${id}`);
  return (
    <VideoProjectCardStyle className={needsAck ? "videoProjectCard needsAck" : "videoProjectCard"} href={url}>
      <Image className={"reelsIcon"} size="small" src={Svg.Reels} />
      <ThumbnailPreview width={3} thumbnailurl={thumbnailUrl} />
      <VideoProjectCardContentStyle>
        <VideoProjectHeader>{statusLabel}</VideoProjectHeader>
        <VideoProjectCardStyle.Description>
          {formatVideoProjectStatusDate(statusDate)}
        </VideoProjectCardStyle.Description>
      </VideoProjectCardContentStyle>
    </VideoProjectCardStyle>
  );
};

export const VideoProjectCard = VideoProjectCardFC;
